import { useDispatch } from 'react-redux';
import { IPatientEnrollmentReq } from './index.type';
import { patientEnrollment } from '../../redux/reducers/loginSlice';

const usePatientEnrollment = () => {
  const dispatch = useDispatch();

  const enrollPatient = (formData: IPatientEnrollmentReq) => {
    dispatch(patientEnrollment(formData));
  };

  return { enrollPatient };
};

export default usePatientEnrollment;
